export default __webpack_public_path__ + "static/media/sv.c5b7a88d.svg";